var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1818 16.4545V17.3636H3.8182V16.4545L5.63638 14.6364V9.18181C5.63638 6.36363 7.48183 3.88182 10.1818 3.08182V2.81818C10.1818 2.33597 10.3734 1.87351 10.7144 1.53253C11.0553 1.19156 11.5178 1 12 1C12.4822 1 12.9447 1.19156 13.2857 1.53253C13.6266 1.87351 13.8182 2.33597 13.8182 2.81818V3.08182C16.5182 3.88182 18.3636 6.36363 18.3636 9.18181V14.6364L20.1818 16.4545ZM13.8182 18.2727C13.8182 18.7549 13.6266 19.2174 13.2857 19.5584C12.9447 19.8993 12.4822 20.0909 12 20.0909C11.5178 20.0909 11.0553 19.8993 10.7144 19.5584C10.3734 19.2174 10.1818 18.7549 10.1818 18.2727M19.0455 2.08182L17.7545 3.37273C18.5234 4.1322 19.1339 5.03675 19.5506 6.03393C19.9672 7.03111 20.1818 8.10108 20.1818 9.18181H22C22 6.51818 20.9455 3.95454 19.0455 2.08182ZM2.00002 9.18181H3.8182C3.8182 6.99999 4.69092 4.90909 6.24547 3.37273L4.95456 2.08182C4.01627 3.01052 3.2719 4.11642 2.76469 5.33528C2.25749 6.55413 1.99756 7.86164 2.00002 9.18181Z",
    fill: "url(#paint0_linear_3614_3022)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3614_3022",
    x1: 16.3747,
    y1: 1.95452,
    x2: 12.1496,
    y2: 20.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.e70f882504ad39e0f47cd7c1e9b08196.svg";
export { ForwardRef as ReactComponent };